import React, { useMemo } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { getAbilityTheme, getAbilityValueBarShades, getAbilityContrastInk } from '../../utils/abilityTheme';

function AbilityScoreTile({ slug, value, label }) {
  const { isDark } = useTheme();
  const shades = useMemo(() => getAbilityValueBarShades(slug), [slug, isDark]);
  const { ink } = getAbilityTheme(slug);
  const contrastInk = getAbilityContrastInk(slug);
  const clampedValue = Math.max(0, Math.min(5, Number(value) || 0));

  return (
    <div
      className="relative overflow-hidden rounded-lg bg-surface-muted border border-edge p-4 min-h-[5.5rem]"
      role="meter"
      aria-label={label}
      aria-valuenow={clampedValue}
      aria-valuemin={0}
      aria-valuemax={5}
    >
      <div className="absolute inset-0 flex flex-row" aria-hidden>
        {[1, 2, 3, 4, 5].map((level) => {
          const shade = shades[level - 1];
          let segmentFill = 0;
          if (clampedValue >= level) {
            segmentFill = 1;
          } else if (clampedValue > level - 1) {
            segmentFill = clampedValue - (level - 1);
          }

          return (
            <div key={level} className="relative h-full flex-1">
              {segmentFill > 0 ? (
                <div
                  className="absolute inset-y-0 left-0"
                  style={{
                    width: `${segmentFill * 100}%`,
                    backgroundColor: shade
                  }}
                />
              ) : null}
            </div>
          );
        })}
      </div>
      <div className="relative z-10 flex h-full flex-col justify-between">
        <p className="text-sm font-medium" style={{ color: ink }}>
          {label}
        </p>
        <p className="text-lg font-semibold" style={{ color: contrastInk }}>
          {value?.toFixed(1)}
        </p>
      </div>
    </div>
  );
}

export default AbilityScoreTile;
